module.exports = __webpack_public_path__ + "assets/7b89a8949a639417f025f64a25042aa8.png";